import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { getClickAttrs } from '../../../../components/Analytics/gtag';

import styles from './topBanner.scss';

const TopBanner = ({ auth }) => {
    const isPowered = auth?.user?.isPowered;
    const hasPastDueSubscription = auth?.user?.hasPastDueSubscription;

    const resumePowerClickAttrs = {
        category: 'Resume Power',
        context: `Power Perks Power Lp Resume Power Button Top Click`,
        location: 'Power Perks page - Top banner - Power Lp',
    };

    const bannerClass = isPowered && !hasPastDueSubscription
        ? `${styles.topBanner} ${styles.powered}`
        : styles.topBanner;

    // Free/basic user - not powered at all
    const isFreeUser = !isPowered && !hasPastDueSubscription;

    return (
        <div className={bannerClass}>
            {isPowered && !hasPastDueSubscription ? (
                // Powered users (monthly or annual)
                <div className={styles.headlineBanner}>
                    <h2 className={styles.headlineTitle}>Power: The most valuable and affordable tennis membership.</h2>
                </div>
            ) : isFreeUser ? (
                // Free/basic users - headline banner
                <div className={styles.headlineBanner}>
                    <h2 className={styles.headlineTitle}>Elevate your game with advanced insights, access to premium travel benefits, and massive discounts on apparel and more.</h2>
                </div>
            ) : (
                // Past due subscription - show resume power
                <>
                    <h2 className={styles.bannerTitle}>Power</h2>
                    <img className={styles.divider} src="img/vertical-line.svg" alt="vertical divider" />
                    <div className={styles.ctaContainer}>
                        <Link
                            className="btn btn-primary text-uppercase"
                            to="/subscriptions"
                            {...getClickAttrs(resumePowerClickAttrs)}
                        >
                            Resume Power
                        </Link>
                    </div>
                </>
            )}
        </div>
    );
};

TopBanner.propTypes = {
    auth: PropTypes.shape({
        user: PropTypes.shape({
            isPowered: PropTypes.bool,
        }),
    }).isRequired,
};

export default TopBanner;
